import ajaxBlocks from '../util/ajaxBlocks';
import appState from '../util/appState';
import common from '../routes/common';
import moment from 'moment';
import notie from 'notie';

import Mousetrap from 'mousetrap';
import 'mousetrap/plugins/global-bind/mousetrap-global-bind';

const daily = {
  init() {
    // JavaScript to be fired on the daily page

    // Init ajaxBlocks
    ajaxBlocks.init();

    daily.updateClientHeaders();

    // Add Item "return" keyboard support
    let addItem = document.querySelector('.addItem[data-type]');
    Mousetrap(addItem).bind('return', e => {
      ajaxBlocks.addClick(e, e.target);
    });

    // Items keyboard control
    Mousetrap.bind('return', e => {
      // Return => edit item
      let focused = document.activeElement;
      if (focused.classList.contains('ajaxblock')) {
        ajaxBlocks.editClick(e, focused);
      }
    }).bind('backspace', e => {
      // Backspace => delete item
      let focused = document.activeElement;
      if (focused.classList.contains('ajaxblock')) {
        e.preventDefault();
        if (confirm('Are you sure?')) {
          ajaxBlocks.deleteItem(focused);
        }
      }
    }).bind('n', e => {
      // N => add new item
      let addItem = document.querySelector('.addItem[data-type]');
      ajaxBlocks.addClick(e, addItem);
    });

    // Watch for state change
    // window.addEventListener('popstate', daily.checkUrl);

    // Watch for custom "save-ajaxblock-form" event
    window.addEventListener('save-ajaxblock', e => {
      // If saving job item, update job detail totals
      if (e.detail.type == 'items') {
        $.getJSON('/inc/ajaxBlocks.php', {
          'action': 'get-days'
        }).done(response => {
          if (response.status === 1) {
            let daysWrap = document.querySelector('.days-wrap');
            daysWrap.innerHTML = response.html;
          }
        });
        daily.updateClientHeaders();
      }
    });

    // Watch for custom "delete-ajaxblock" event
    window.addEventListener('delete-ajaxblock', e => {
      // If deleting job item, update job detail totals
      if (e.detail.type == 'items') {
        // daily.updateJobTotal();
        daily.updateClientHeaders();
      }
    });

  },

  updateClientHeaders() {
    let items = document.querySelectorAll('.items.ajaxblock');
    let client = '';
    items.forEach(el => {
      let itemClient = el.querySelector('.client');
      if (client != itemClient.innerText) {
        client = itemClient.innerText;
        itemClient.classList.add('client-header');
      } else {
        itemClient.classList.remove('client-header');
      }
    });
  },

  // Format minutes into HH:MM
  formatTime(mins) {
    let h = Math.floor(mins / 60);
    let m = mins % 60;
    h = h < 10 ? '0' + h : h;
    m = m < 10 ? '0' + m : m;
    return `${h}:${m}`;
  },

  finalize() {
    // JavaScript to be fired on the daily page, after the init JS
  },
};

export default daily
